export default __webpack_public_path__ + "static/covid-press-NP news 24-cc6e8b26848eda5d4914cee268d59061.png";